import React from 'react'
import image from './../images/background.png'
import './hero.css'

function Hero() {
    return (
        <section className="hero-section" id="home">
            <div className="position-absolute w-100 h-100 hero-bg" style={{ backgroundImage: `url('${image}')`, top: 0, left: 0, zIndex: -1 }}></div>
        </section>
    )
}

export default Hero
